import { useQuery } from 'react-query';

import client, { isAxiosError } from '@/apis/aniftyBackend/client';
import { QueryConfig } from '@/utils/react-query';

export const getIsUserFavorited = async ({
  userID,
  targetUserID,
}: {
  userID: string;
  targetUserID: string;
}): Promise<boolean> => {
  try {
    await client.get(`/api/users/${userID}/favorite_users/${targetUserID}`);
    return true;
  } catch (e) {
    if (isAxiosError(e) && e.response.status === 404) {
      return false;
    }
    throw e;
  }
};

const generateQueryKey = (userID: string, targetUserID: string) => [
  'userFavorite',
  userID,
  targetUserID,
];

type UseGetUserFavoriteOptions = {
  userID: string;
  targetUserID: string;
  config?: QueryConfig<typeof getIsUserFavorited>;
};

export const useIsUserFavorited = ({
  userID,
  targetUserID,
  config,
}: UseGetUserFavoriteOptions) => {
  return useQuery({
    ...config,
    queryKey: generateQueryKey(userID, targetUserID),
    queryFn: () => getIsUserFavorited({ userID, targetUserID }),
  });
};

useIsUserFavorited.getKey = generateQueryKey;
